import React, { Fragment } from 'react'
import { ShippingOptionsProps } from './ShippingOptions.types'
import styles from './ShippingOptions.module.scss'
import cl from 'classnames'
import {
  LightTag, H2, HorizontalLine, LabeledLine,
  NoneLabel, SectionContainer, Text1
} from 'components/shared'
import { formatPrice } from 'utilities'

const ShippingOptionsComponent = (props: ShippingOptionsProps) => {
  const {
    shippings
  } = props

  const hasShippings = Boolean(shippings && shippings.length)

  return (
    <SectionContainer className={cl(styles.container)} extraPaddingBottom={hasShippings}>
      <H2>Shipping options</H2>

      {hasShippings
        ? (
          <div>

            {shippings.map((shipping, index) => {
              const isFirst = index === 0

              return (
                <Fragment key={shipping.id}>
                  {!isFirst && <HorizontalLine />}
                  <div className={cl({ [styles.marginTop]: isFirst })}>
                    <LabeledLine
                      label='Name'
                    >
                      {shipping.name}
                    </LabeledLine>
                    <LabeledLine
                      label='Price'
                      alignItems='flexStart'
                    >
                      <Text1>{formatPrice(shipping.price)}</Text1>
                      {!!shipping.freeAmount && (
                        <Text1 style={{marginLeft : "10px"}}>
                          Free shipping above: {formatPrice(shipping.freeAmount)}
                        </Text1>
                      )}
                    </LabeledLine>
                    <LabeledLine
                      label='Ships to'
                      preset='tags'
                    >
                      {shipping.countries.map(country => {
                        return (
                          <LightTag
                            key={country}
                            text={country}
                          />
                        )
                      })}
                    </LabeledLine>
                  </div>
                </Fragment>
              )
            })}

          </div>
        )
        : (
          <NoneLabel />
        )}

    </SectionContainer>
  )
}

const ShippingOptions = ShippingOptionsComponent
export { ShippingOptions }
